import {combineReducers} from 'redux';

import reisadviezenReducer from './reisadviezen';
import dienstregelingReducer from './dienstregeling';
import storingenReducer from './storingen';
import stopsReducer from './stops';
import stopReducer from './stop';
import shopReducer from './shop';

const rootReducer = combineReducers({
  dienstregeling: dienstregelingReducer,
  reisadviezen: reisadviezenReducer,
  storingen: storingenReducer,
  stops: stopsReducer,
  stop: stopReducer,
  shop: shopReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/root.js